import React, { useState, useEffect } from 'react';

import { ThreeDots } from 'svg-loaders-react';

import validateFormData from '../../validation/validateFormData';

import styles from './BusinessDetails.module.scss';

const BusinessDetails = ({ setStatus, agentData, dispatch, loading, createAgent, state = {} }) => {
    const [validationErrors, setValidationErrors] = useState({ errors: true });

    useEffect(() => {
        let states = state?.states;
        if (states && states.length > 0 && agentData.state_id) {
            const selectedState = states.find((state) => {
                return parseInt(state.id) === parseInt(agentData.state_id);
            });
    
            if (selectedState) {
                const generatedCode = Math.floor(10000000 + Math.random() * 90000000);
    
                dispatch({
                    type: 'SET_AGENT_DATA',
                    payload: {
                        agent_code: `CI/AGT/${selectedState.name}/${generatedCode}`, // or .code or .id depending on what you need
                    },
                });
            } else {
                console.warn("No matching state found for state_id:", agentData.state_id);
            }
        }
    }, [agentData.state_id]);
    

    const handleOnChange = ({ target }) => {
        setValidationErrors({ ...validationErrors, [target.name]: '' });
        dispatch({
            type: 'SET_AGENT_DATA',
            payload: { [target.name]: target.value },
        });
    };

    const handleProceed = (e) => {
        e.preventDefault();

        const {
            category,
            business_name,
            business_address,
            state_id,
            business_type,
            agent_type,
            local_government_id,
            rc_number,
            doi,
            tin,
        } = agentData;

        const state = {
            category,
            business_name,
            business_address,
            state_id,
            business_type,
            agent_type,
            local_government_id,
            rc_number,
            doi,
            tin,
        };

        const keys = Object.keys(state);
        const errors = validateFormData(agentData, keys);

        setValidationErrors(errors);

        if (Object.keys(errors).length > 0) return;

        // setStatus('account');
        
        createAgent(agentData);
    };

    const LGAOptions = () => {
        if (state.lgas !== undefined) {
            let lgas = state.lgas;
            let lgaOpt = lgas.filter(
                (lga, id) => lga.state_id == agentData.state_id
            );
            return lgaOpt;
        }
    };

    return (
        <div className={styles.container}>
            <form className={styles.form} onSubmit={handleProceed}>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='category'>
                        Account Category
                    </label>
                    <select
                        className={styles.select}
                        name='category'
                        onChange={handleOnChange}
                        value={agentData.category}
                    >
                        <option value=''>Select Category</option>
                        <option value='individual'>Individual</option>
                        <option value='business_name'>Business Name (BN)</option>
                        <option value='registered_company'>Registered Company (RC)</option>
                    </select>
                    {validationErrors.category && (
                        <p className={styles.errorText}>
                            {validationErrors.category.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='business_name'>
                        Business Name
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='business_name'
                        onChange={handleOnChange}
                        value={agentData.business_name}
                    />
                    {validationErrors.business_name && (
                        <p className={styles.errorText}>
                            {validationErrors.business_name.text}
                        </p>
                    )}
                </div>
                {(agentData.category === 'business_name' || agentData.category === 'registered_company') && (
                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="rc_number">
                            Registeration Number(RC/BN)
                        </label>
                        <input
                            type="text"
                            className={styles.input}
                            name="rc_number"
                            value={agentData.rc_number}
                            onChange={handleOnChange}
                        />
                        {validationErrors.rc_number && (
                            <p className={styles.errorText}>
                                {validationErrors.rc_number.text}
                            </p>
                        )}
                    </div>
                )}
                
                {(agentData.category === 'business_name' || agentData.category === 'registered_company') && (
                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="doi">
                            Date of Incorporation
                        </label>
                        <input
                            type="date"
                            className={styles.input}
                            name="doi"
                            value={agentData.doi}
                            onChange={handleOnChange}
                        />
                        {validationErrors.doi && (
                            <p className={styles.errorText}>
                                {validationErrors.doi.text}
                            </p>
                        )}
                    </div>
                )}

                {(agentData.category === 'business_name' || agentData.category === 'registered_company') && (
                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="tin">
                            Tax Identification Number(optional)
                        </label>
                        <input
                            type="text"
                            className={styles.input}
                            name="tin"
                            value={agentData.tin}
                            onChange={handleOnChange}
                        />
                        {validationErrors.tin && (
                            <p className={styles.errorText}>
                                {validationErrors.tin.text}
                            </p>
                        )}
                    </div>
                )}
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='business_address'>
                        Business Address
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='business_address'
                        onChange={handleOnChange}
                        value={agentData.business_address}
                    />
                    {validationErrors.business_address && (
                        <p className={styles.errorText}>
                            {validationErrors.business_address.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='state_id'>
                        State
                    </label>
                    <select
                        className={styles.select}
                        name='state_id'
                        onChange={handleOnChange}
                        value={agentData.state_id}
                    >
                        <option value=''>Select State</option>
                        {state.states &&
                            state.states.map((state, index) => {
                                return (
                                    <option
                                        value={state.id}
                                        key={`${state.id}`}
                                    >
                                        {state.name}
                                    </option>
                                );
                            })}
                    </select>
                    {validationErrors.state_id && (
                        <p className={styles.errorText}>
                            {validationErrors.state_id.text}
                        </p>
                    )}
                </div>

                <div className={styles.formGroup}>
                    <label
                        className={styles.label}
                        htmlFor='local_government_id'
                    >
                        LGA
                    </label>
                    <select
                        className={styles.select}
                        name='local_government_id'
                        onChange={handleOnChange}
                        value={agentData.local_government_id}
                    >
                        <option value=''>Select LGA</option>
                        {LGAOptions()?.map((lga, index) => {
                            return (
                                <option value={lga.id} key={`${lga.id}`}>
                                    {lga.name}
                                </option>
                            );
                        })}
                    </select>
                    {validationErrors.local_government_id && (
                        <p className={styles.errorText}>
                            {validationErrors.local_government_id.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='business_type'>
                        Business Type
                    </label>
                    <select
                        className={styles.select}
                        name='business_type'
                        onChange={handleOnChange}
                        value={agentData.business_type}
                    >
                        <option value=''>Select Business Type</option>
                        {state.business_types &&
                            state.business_types.map((bus, index) => (
                                <option value={bus} key={index}>
                                    {bus}
                                </option>
                            ))}
                    </select>
                    {validationErrors.business_type && (
                        <p className={styles.errorText}>
                            {validationErrors.business_type.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='agent_type'>
                        Agent Type
                    </label>
                    <select
                        className={styles.select}
                        name='agent_type'
                        onChange={handleOnChange}
                        value={agentData.agent_type}
                    >
                        <option value=''>Select type</option>
                        {state.agent_types &&
                            state.agent_types.map((agent, index) => (
                                <option value={agent} key={index}>
                                    {agent}
                                </option>
                            ))}
                    </select>
                    {validationErrors.agent_type && (
                        <p className={styles.errorText}>
                            {validationErrors.agent_type.text}
                        </p>
                    )}
                </div>
                <div className={`${styles.submit} ${styles.formGroup}`}>
                    <button
                        onClick={() => setStatus('personal')}
                        className={`${styles.button} ${styles.back}`}
                    >
                        Back
                    </button>
                    <button className={`${styles.button}`} type='submit'>
                        {loading ? <ThreeDots /> : 'Submit'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BusinessDetails;
